<template>
  <div>
    <el-dialog
      :title="modalType['type']"
      :visible.sync="showEdit"
      @close="remarkClose"
      width="60%"
      class="abnormal complaint remark_modal"
      :append-to-body="true"
      id="orderlist"
    >
      <div class="remark-add markup-t">
        <div class="increase_price_form">
          <el-form
            :model="params"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-row :gutter="36">
              <!-- 应收 -->
              <el-col :span="8" v-if="modalType['type'] != '备注'">
                <el-form-item
                  :label="modalType['type']"
                  :prop="modalType['value']"
                >
                  <el-input-number
                    class="shuzikuang screen"
                    placeholder="请输入"
                    v-model="params[modalType['value']]"
                    controls-position="right"
                    :min="0"
                    :max="999"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <template v-if="modalType['type'] == '备注'">
                <el-col :span="8">
                  <el-form-item label="订单编号">
                    {{ yingkui.orderNo || "/" }}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="物流号">
                    {{ yingkui.logisticsNo || "/" }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    :label="modalType['type']"
                    :prop="modalType['value']"
                  >
                    <el-input
                      class="default-input default-input-remark"
                      v-model="params[modalType['value']]"
                      placeholder="请输入备注信息"
                      type="textarea"
                      :maxlength="500"
                      @input="$forceUpdate()"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { putAction } from "@/api/manage";

export default {
  components: {},
  data() {
    return {
      showEdit: false,
      modalType: {},
      params: {},
      loading: false,
      yingkui: {},
      rules: {
        orderReceivable: [
          { required: true, message: "请输入订单应收", trigger: "change" },
        ],
        otherReceivable: [
          { required: true, message: "请输入其他应收", trigger: "change" },
        ],
        remark: [{ required: true, message: "请输入备注", trigger: "change" }],
      },
    };
  },
  created() {},
  methods: {
    init(type, row) {
      this.yingkui = row || {};
      this.modalType = type;
      if (this.modalType["type"] == "备注")
        this.params = Object.assign({ remark: row.remark });
      if (this.modalType["type"] == "订单应收")
        this.params = Object.assign({ orderReceivable: row.orderReceivable });
      if (this.modalType["type"] == "其他应收")
        this.params = Object.assign({ otherReceivable: row.otherReceivable });
      this.showEdit = true;
    },
    // 备注弹窗关闭
    remarkClose() {
      this.params = {};
      this.modalType = {};
      this.yingkui = {};
      this.showEdit = false;
      this.loading = false;
      this.$refs["ruleForm"].resetFields();
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = Object.assign(this.params, {
            revenueId: this.yingkui.id,
          });
          putAction("/order/api/order/revenue/edit", this.$qs.stringify(params))
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("ok");
                this.remarkClose();
              }
            })
            .finally(() => {
              this.remarkClose();
            });
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/.screen {
  width: 230px !important;
  height: 40px !important;
  & > span {
    display: none;
  }
  input {
    width: 100% !important;
    height: 40px;
    text-align: left;
    line-height: 0;
    border: 1px solid #dcdfe6 !important;
    // padding: 0 15px !important;
  }
}
/deep/.el-form-item {
  margin-bottom: 16px;
  .default-input-remark {
    width: 93%;
    height: 80px;
    textarea {
      height: 100%;
      border-radius: 2px;
      font-size: 12px;
      resize: none;
    }
  }
}

/deep/.default-input {
  width: 100%;
  textarea {
    height: 80px;
  }
  .el-input__suffix {
    width: auto;
  }
  .el-input__inner {
    width: 100%;
  }
}
#orderlist /deep/ .el-input__inner {
  height: 34px !important;
  margin-top: 0 !important;
}
.increase_price_form {
  background: #fff;
  padding: 20px;
  .zhuijia {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .default-input {
      width: 77%;
      &/deep/.el-input__suffix {
        width: auto !important;
      }
    }
    .default-input-remark {
      width: 93%;
      height: 80px;
      &/deep/textarea {
        height: 100%;
        border-radius: 2px;
        font-size: 12px;
        resize: none;
      }
    }
  }
}
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover,
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover {
  border-color: #3455d3;
}

#orderlist.complaint /deep/ .complaint-img > span {
  display: flex;
  flex-wrap: wrap;
}

#orderlist.complaint .complaint-img /deep/ .ant-upload-list {
  width: auto !important;
}

#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card {
  margin-right: 0;
  border-radius: 2px;
}
#orderlist.remark_modal {
  &/deep/.el-dialog {
    width: 1000px !important;
  }

  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }

  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }

  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;

    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
    }
  }

  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;

    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}

#orderlist /deep/.genjinupload {
  .ant-upload.ant-upload-select-picture-card {
    width: 80px !important;
    height: 80px !important;
    margin-left: 0 !important;
  }

  .ant-upload-list {
    // height: 80px !important;
  }

  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload-list-picture-card-container {
    width: 80px !important;
    height: 80px !important;
    padding: 0;
  }
}
</style>
